import { styled } from "@mui/material/styles";
import { Container } from "@mui/material";
import { useEffect, useState } from "react";
import HeaderComp from "../headerComp/headerComp";
import CelebrationGrid from "../celebrationGrid/CelebrationGrid";
import { MAVINTERNATIONAL } from "../../utils/const";
import { listFoldersInS3 } from "../api/api";

const StyledConatiner = styled(Container)({
  marginTop: "1em",
});

const GalleryWrapComponent = () => {
  const isInternationalURL = window.location.host.includes(MAVINTERNATIONAL);
  const [year, setYear] = useState(new Date().getFullYear().toString());
  const [folders, setFolders] = useState<string[]>([]);

  useEffect(() => {
    listFoldersInS3(year).then((response) => setFolders(response));
  }, []);

  return (
    <StyledConatiner maxWidth="xl">
      <HeaderComp
        year={year}
        setYear={setYear}
        isInternationalURL={isInternationalURL}
        onFoldersLoaded={setFolders}
      />
      <CelebrationGrid year={year} folders={folders} />
    </StyledConatiner>
  );
};

export default GalleryWrapComponent;
